export const navigatorWebShare = async (payload: ShareData) => {
  if (window.parent === window) {
    await navigator.share(payload);
  } else {
    window.parent.postMessage(
      {
        code: 'NAVIGATOR_SHARE',
        payload,
      },
      '*',
    );
  }
};
